var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.err)?[_c('Header',{attrs:{"logo":_vm.logo}}),_vm._v(" "),_c('Turntable',{attrs:{"turntable":_vm.turntable}}),_vm._v(" "),_c('Rule',{attrs:{"rule":_vm.rule}})]:_c('div',{staticClass:"err"},[_c('span',{domProps:{"textContent":_vm._s(_vm.err)}})])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e252f91c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 